import { Interweave } from 'interweave';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const DescriptionWrapper = styled.div`
  height: ${p => p.height}px;
  overflow: hidden;
  .description-field ul {
    margin-bottom: 0px;
    &[data-checked=false] {
      padding-left: 20px;
      list-style: none;
      li::before {
        content: '\\2610';
        cursor: pointer;
        margin-right: 10px;
      } 
    }
    &[data-checked=true] {
      padding-left: 20px;
      list-style: none;
      li::before {
        content: '🗹';
        cursor: pointer;
        margin-right: 10px;
      } 
    }
  }
  .description-field a {
    text-decoration: underline;
  }
`;

const ShowToggle = styled.p`
  text-decoration: underline;
  margin-top: 20px;
  color: ${p => p.theme.colors.theme};
  font-weight:  400;
  cursor: pointer;
`;

const descriptionMinHeight = 250;

const TicketDescription = ({
  description = '',
}) => {
  const [descriptionOverflow, setDescriptionOverflow] = useState(false);
  const [descriptionHeight, setDescriptionHeight] = useState(descriptionMinHeight);

  const getDescriptionOverflow = () => {
    // eslint-disable-next-line prefer-destructuring
    const element = document.getElementsByClassName('description-field')[0];
    if (element) {
      const elementHeight = element.offsetHeight;
      if (elementHeight > descriptionMinHeight) {
        setDescriptionOverflow(true);
      } else {
        setDescriptionOverflow(false);
      }
    }
  };

  useEffect(() => {
    if (document.getElementsByClassName('description-field')[0]) {
      getDescriptionOverflow();
    }
  });

  return <>
    <DescriptionWrapper height={descriptionHeight}>
      <Interweave
        className='description-field'
        content={description}
      />
    </DescriptionWrapper>
    {descriptionOverflow ?
      <ShowToggle
        onClick={() =>
          setDescriptionHeight(s =>
            s === descriptionMinHeight &&
              document.getElementsByClassName('description-field')[0] ?
              // eslint-disable-next-line max-len
              document.getElementsByClassName('description-field')[0]?.offsetHeight :
              descriptionMinHeight,
          )
        }
      >
        {descriptionHeight === descriptionMinHeight ?
          <FormattedMessage id='publishSteps.SHOW_MORE' /> :
          <FormattedMessage id='publishSteps.SHOW_LESS' />
        }
      </ShowToggle>
      : null
    }
  </>;
};

TicketDescription.propTypes = {
  description: PropTypes.string,
};

export default TicketDescription;
